import { render } from "./openTickets.vue?vue&type=template&id=4142fbf4&scoped=true"
import script from "./openTickets.vue?vue&type=script&lang=js"
export * from "./openTickets.vue?vue&type=script&lang=js"

import "./openTickets.vue?vue&type=style&index=0&id=4142fbf4&scoped=true&lang=scss"
import "./openTickets.vue?vue&type=style&index=1&id=4142fbf4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4142fbf4"]])

export default __exports__